import { useEffect, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { webApi } from "@/lib/webApi";

export const CutoutPreview = ({ file, onRetake, onReady, disabled }) => {
  const [state, setState] = useState({ status: "idle" });

  useEffect(() => {
    if (!file) return undefined;
    const ctrl = new AbortController();
    let url;
    setState({ status: "loading" });
    onReady?.(null);
    const form = new FormData();
    form.append("file", file);
    webApi
      .post("/thrift/cutout-preview", form, { responseType: "blob", signal: ctrl.signal })
      .then(({ data }) => { url = URL.createObjectURL(data); setState({ status: "done", url }); onReady?.({ file, blob: data }); })
      .catch(async (e) => {
        if (ctrl.signal.aborted) return;
        let detail = "";
        try { detail = JSON.parse(await e?.response?.data?.text?.()).detail; } catch { /* not JSON */ }
        setState({ status: "failed", error: detail ? `${detail}.` : "Couldn't make a preview." });
      });
    return () => { ctrl.abort(); if (url) URL.revokeObjectURL(url); };
  }, [file]); // eslint-disable-line react-hooks/exhaustive-deps

  const retake = (e) => {
    const f = [...e.target.files].find((x) => x.type.startsWith("image/"));
    if (f) onRetake(f);
    e.target.value = "";
  };

  return (
    <div data-testid="thrift-cutout-preview" className="flex gap-3 items-stretch bg-[#0F0F0F] p-3">
      <div className="h-36 w-28 shrink-0 flex items-center justify-center">
        {state.status === "loading" && <Loader2 data-testid="thrift-cutout-preview-loading" className="h-6 w-6 text-[#C5A059] animate-spin" />}
        {state.status === "done" && <img data-testid="thrift-cutout-preview-image" src={state.url} alt="Cut-out preview" className="max-h-full max-w-full object-contain drop-shadow-[0_10px_10px_rgba(0,0,0,0.7)]" />}
        {state.status === "failed" && <span data-testid="thrift-cutout-preview-error" className="text-[11px] text-center text-white/60">{state.error}</span>}
      </div>
      <div className="flex flex-col justify-between py-1 min-w-0">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">Rail preview</p>
          <p className="text-xs text-white/60 mt-1 leading-snug">This is how the cover photo will hang on the Thrift rail. Not happy? Retake it.</p>
        </div>
        <label data-testid="thrift-cutout-retake-btn" className={`self-start whitespace-nowrap inline-flex items-center gap-2 h-9 px-4 rounded-full border border-white/20 text-white text-xs cursor-pointer hover:border-[#C5A059] transition-colors ${disabled ? "pointer-events-none opacity-50" : ""}`}>
          <Camera className="h-3.5 w-3.5" /> Retake photo
          <input data-testid="thrift-cutout-retake-input" type="file" accept="image/*" capture="environment" onChange={retake} className="sr-only" />
        </label>
      </div>
    </div>
  );
};
